// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d336bdfb","795":"2d908b44","833":"dac0ff8f"}[chunkId] + ".chunk.js";
};